<template>
  <div class="row m-b-sm" v-if="user.admin">
    <div class="col-lg-4 col-sm-4 m-t-sm">
      <v-select placeholder="Clients" :options="f.clients" multiple label="name" index="id" v-model="filters['clients']" @input="loadOrders"></v-select>
    </div>
    <div class="col-lg-4 col-sm-4 m-t-sm">
      <label>Show Completed</label>
      <input type="checkbox" class="m-l-sm"  v-model="showCompleted">
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../../mixins/helperMixin'
import axios from 'axios'
import { LINK_ORDERS_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      filters: {},
      multiFilters: {},
      showCompleted: false
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      order: 'getLinkOrder',
      user: 'getUser'
    })
  },
  watch: {
    showCompleted: function (val) {
      this.filters['showCompleted'] = val ? 1 : 0
      this.loadOrders()
    }
  },
  mounted () {
    if (!this.user.admin) {
      this.showCompleted = true
    } else {
      this.loadOrders()
    }
  },
  methods: {
    loadOrders () {
      this.$nextTick(() => {
        axios.get(`/pbn/links/orders?${this.buildQuery(this.filters)}`)
          .then(r => {
            this.$store.commit(LINK_ORDERS_SET, r.data.data)
          })
          .catch()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Orders/Filters.vue